<template>
  <div id="anchor-coupon" class="form-card">
    <h4>優惠碼資料</h4>
    <div class="row">
      <div class="col-md-12 mb-3">
        <div class="coupon-info">
          <li>優惠碼只接受文字、連結或QR Code版本。</li>
          <li>
            通用優惠碼：推薦用於「未有限額」之優惠（例：所有用戶均會被發配同一組優惠碼）。
          </li>
          <li>
            獨特優惠碼：推薦用於「有名額限制」之優惠，每個獨特優惠碼為一次性優惠碼，一個優惠碼代表一個名額（例：所有用戶均會被發配不同的一次性優惠碼以防止重覆使用）。
          </li>
          <li>
            連結優惠：門市如以條碼兌換優惠，可輸入條碼之圖片連結，網上商店則可上載獨特購物／優惠兌換網址。
          </li>
          <li>
            QR Code 優惠碼：只須填寫優惠碼數量，系統將自動生成QR Code（必須建立附屬帳戶以使用QR Code及其兌換功能）。
          </li>
          <li>
            所有優惠類型均可自訂每人可換領數量上限。
          </li>
        </div>
        <AGCRadioGroup
          v-model="inputVal.couponMeta.codeType"
          name="優惠類型"
          :options="codeTypeOptions"
           @change="handleClearCode()"
          :disabled="readOnly"
          label="優惠類型"
          required
        >
          <template v-slot:subLabel>
            <span style="font-size: 13px; font-weight: bold; color: #dc3545;">
              (請小心選擇優惠類型，一旦提交後便不能作出修改。)
            </span>
          </template>
        </AGCRadioGroup>
        <AGCRadioGroup
          v-if="inputVal.couponMeta.codeType !== 'mc-qr'"
          v-model="codeFormatChoice"
          name="優惠格式"
          :options="codeFormatOptions"
          @change="handleClearCode()"
          :disabled="readOnly"
          label="優惠格式"
          required
        >
          <template v-slot:subLabel>
            <span style="font-size: 13px; font-weight: bold; color: #dc3545;">
              (請小心選擇優惠格式，一旦提交後便不能作出修改。)
            </span>
          </template>
        </AGCRadioGroup>
        <div class="code-input" v-if="inputVal.reward.draftData">
          <div
            class="multi-code"
            :class="[codeFormatChoice === 'multiple_code' ? 'active' : '']"
            v-if="codeFormatChoice === 'multiple_code' && inputVal.couponMeta.codeType !== 'mc-qr'"
          >
            <b-button
            v-if="((inputVal.couponMeta.codes && inputVal.couponMeta.codes.length > 0)  ||
            (inputVal.reward.draftData.codes && inputVal.reward.draftData.codes.length > 0)) &&
            !readOnly"
            @click="$bvModal.show('modal-remove-code')" class="float-right" variant="link">全部清除
            </b-button>

            <BaseActionModal
              id="modal-remove-code"
              title="確定全部清除"
              okVariant="primary"
              footerClass="d-flex justify-content-center"
              @cancel-click="handleCancel"
              @ok-click="batchDeleteCodes"
            >
            </BaseActionModal>

            <AGCFormTags
              v-if="inputVal.reward.draftData.codes"
              input-id="tags-basic"
              v-model="inputVal.reward.draftData.codes"
              :placeholder="handleCodePlaceholder"
              :disabled="readOnly"
              name="優惠碼"
              :rules="couponCodeRules"
              :validate-reg-ex="tagValidateRegEx"
            >
            <template v-slot:invalidTag>
              <template v-if="inputVal.couponMeta.codeType === 'link'">
                優惠碼無效，請創建一組有效的連結
              </template>
              <template v-else>
                優惠碼無效，請創建一組15位內的字母或/及數字
              </template>
            </template>
            </AGCFormTags>
            <div class="text-wrapper">
              <span class="left">
                或
              </span>
              <span class="right">
                優惠碼總數：
                <span v-if="inputVal.reward.draftData.codes">
                  {{ inputVal.reward.draftData.codes.length }}
                </span>
              </span>
            </div>
            <ExcelLoader
              @result="handleExcelResult"
              @error="handleExcelError"
              :readOnly="readOnly"
              :validate-reg-ex="tagValidateRegEx"
            />
            <AGCLabel>
              <template v-slot:subLabel>
                <slot name="subLabel">*只支援xlsx 格式</slot>
              </template>
            </AGCLabel>
          </div>
          <div
            class="single-code"
            :class="[codeFormatChoice === 'single_code' ? 'active' : '']"
            v-else
          >
            <AGCInput
              :disabled="readOnly"
              v-model="inputVal.couponMeta.singleCode"
              name="優惠碼"
              :rules="singleCodeRules"
              :custom-messages="{
                max: () =>
                  `優惠碼無效，請創建一組15位內的字母/及數字`,
              }"
              type="text"
              min="1"
              :placeholder="handleCodePlaceholder"
              required
              style="width: 50%;"
            ></AGCInput>
            <div class="mt-3 d-flex align-items-end">
              <AGCRadioGroup
                class="custom-quantity"
                v-model="quantity.type"
                name="quantity"
                :options="quantity.options"
                :disabled="readOnly"
                label="供應數量"
                required
              >
              </AGCRadioGroup>
              <AGCInput
                v-if="quantity.type === 'CUSTOM' && codeFormatChoice === 'single_code'"
                :disabled="quantity.type === 'INFINITY' || readOnly"
                v-model="inputVal.reward.draftData.quantity"
                class="custom-input"
                name="供應數量"
                rules="minValue: 1|required"
                type="number"
                min="1"
                placeholder="供應數量"
                required
              ></AGCInput>
            </div>
          </div>
          <AGCLabel required
            v-if="inputVal.couponMeta.codeType === 'mc-qr'">
            <slot>優惠碼數量</slot>
            <template v-slot:subLabel>
              <slot name="subLabel">(提交後如需更改優惠碼數量，請聯絡U Lifestyle。)</slot>
            </template>
          </AGCLabel>
          <AGCInput
            v-if="inputVal.couponMeta.codeType === 'mc-qr'"
            v-model="inputVal.reward.draftData.quantity"
            id="tag-on-cover"
            name="優惠碼數量"
            :rules="{'required': true, 'minValue':mcqrCodesMinCal}"
            type="number"
            min="1"
            class="custom-input"
            placeholder="數量"
            :disabled="readOnly"
          >
          </AGCInput>
          <div class="mt-3 d-flex align-items-end">
            <AGCRadioGroup
              class="custom-limit"
              v-model="limit.type"
              label="每人可換領數量上限"
              name="limit"
              :options="limit.options"
              :disabled="readOnly"
              required
            >
            </AGCRadioGroup>
            <AGCInput
              v-if="limit.type === 'CUSTOM'"
              :disabled="limit.type === 'INFINITY' || readOnly"
              v-model="inputVal.reward.maxRedeem"
              id="custom-limit"
              class="custom-input"
              name="每人可換領數量上限"
              :rules="maxRedeemRules"
              :custom-messages="{
                maxValue: () =>
                  `每人可換領數量上限必須小於或等於優惠碼總數`,
              }"
              type="number"
              min="1"
              max="999"
              placeholder="數量上限"
            ></AGCInput>
          </div>
          <div class="mt-3">
            <template v-if="isUFUN">
              <AGCLabel>
                <slot>所需U Fun</slot>
                <template v-slot:subLabel>
                  <slot name="subLabel">(所需U Fun由 U Lifestyle保留最終決定權)</slot>
                </template>
              </AGCLabel>
              <div class="d-flex flex-wrap flex-md-nowrap align-items-end pt-1 pb-2">
                <AGCInput
                  v-if="role === 'admin' && (inputVal.reward.cost || !readOnly)"
                  style="display: inline-block"
                  :disabled="readOnly"
                  v-model="inputVal.reward.cost"
                  id="cost"
                  name="所需U Fun"
                  placeholder="所需U Fun"
                  type="number"
                  min="10"
                  max="1000"
                  :rules="'required|minValue:10|maxValue:1000'"
                ></AGCInput>
                <b-form-group v-else>
                  <b-form-radio
                    name="ufun-request"
                    v-model="radioDefault"
                    value="default"
                    :disabled="readOnly"
                  >
                    <img class="ufunlabel-icon" src="../../assets/img/ufun@3x.png" />
                    <template v-if="inputVal.reward.cost">
                      {{ inputVal.reward.cost }}
                    </template>
                    <template v-else>
                      10~1000 不等
                    </template>
                  </b-form-radio>
                </b-form-group>
              </div>
              <template v-if="role === 'admin'">
                <AGCLabel>
                  <slot>原有U Fun</slot>
                </AGCLabel>
                <div class="d-flex flex-wrap flex-md-nowrap align-items-end pt-1 pb-2">
                  <AGC-Input
                    style="display: inline-block"
                    :disabled="readOnly"
                    v-model="inputVal.reward.originalCost"
                    id="original-cost"
                    name="原有U Fun"
                    placeholder="原有U Fun"
                    type="number"
                    min="10"
                    :rules="minOriginalCost"
                  ></AGC-Input>
                </div>
              </template>
            </template>
            <template v-else>
              <AGCLabel required>
                <slot>
                  售價
                </slot>
                <template v-slot:subLabel>
                  <img
                    src="../../assets/img/help-24px-blue.svg"
                    alt="Hover for help"
                    id="tooltip-price"
                  />
                  <b-tooltip target="tooltip-price" placement="right" variant="light">
                    <p>原價即商品原價格，如：現金券價值$250，現售$200，請填寫$250。並會顯示於平台上。</p>
                    <p>優惠價即提供優惠售賣價格，如：現金券價值$250，現售$200，請填寫$200。並會顯示於平台上。</p>
                  </b-tooltip>
                </template>
              </AGCLabel>
              <div class="d-flex flex-wrap flex-md-nowrap pt-1 pb-2">
                <label for="original-price">
                  <AGCInput
                    style="display: inline-block"
                    :disabled="readOnly"
                    v-model="inputVal.reward.originalPrice"
                    id="original-price"
                    name="原價"
                    step="0.1"
                    placeholder="原價 HK$"
                    prepend="原價 HK$"
                    type="number"
                    min="10"
                    :rules="'required|decimal:1|minHKD:10'"
                    class="mr-2"
                  ></AGCInput>
                </label>
                <label for="discount-price">
                  <AGCInput
                    style="display: inline-block"
                    :disabled="readOnly"
                    v-model="inputVal.reward.price"
                    id="discount-price"
                    name="優惠價"
                    prepend="優惠價 HK$"
                    step="0.1"
                    placeholder="優惠價 HK$"
                    type="number"
                    min="10"
                    :rules="'required|decimal:1|minHKD:10|maxValue:@原價'"
                    class="mr-2"
                  ></AGCInput>
                </label>
                <div class="merchant-receivable-price">
                  <div class="title d-flex justify-content-center">
                    商戶可收取金額
                    <img
                      class="ml-1"
                      src="../../assets/img/help-24px-blue.svg"
                      alt="Hover for help"
                      id="tooltip-merchant-receivable-price"
                  /></div>
                   <span style="font-size: 14px;">(只供參考)</span>
                  <b-tooltip
                    target="tooltip-merchant-receivable-price"
                    placement="top"
                    variant="light"
                  >
                    <p>每售出一件，U Lifestyle優惠商戶中心將會收取最終售價的5%作為行政成本。即商戶最終可收取以下顯示的金額。</p>
                  </b-tooltip>
                  <div>HK$ {{ merchantReceivablePrice }}</div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  tap,
  pluck,
} from 'rxjs/operators';
import { mapGetters } from 'vuex';

import {
  BFormGroup,
  BFormRadio,
  BTooltip,
  BButton,
} from 'bootstrap-vue';
import AGCRadioGroup from '@/components/form/AGCRadioGroup.vue';
import AGCFormTags from '@/components/form/AGCFormTags.vue';
import AGCInput from '@/components/form/AGCInput.vue';
import AGCLabel from '@/components/form/AGCLabel.vue';
import BaseActionModal from '@/components/BaseActionModal.vue';
import { getCodeType } from '@/helpers/coupon';
import formMixin from '../../mixins/form';
import vModelMixin from '../../mixins/v-model';
import toastSettings from '../../helpers/toast-settings';

import ExcelLoader from '../ExcelLoader.vue';

export default {
  mixins: [formMixin, vModelMixin],
  components: {
    ExcelLoader,
    AGCLabel,
    AGCInput,
    AGCRadioGroup,
    AGCFormTags,
    BaseActionModal,
    BFormGroup,
    BFormRadio,
    BTooltip,
    BButton,
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    isUFUN: {
      type: Boolean,
    },
    haveSubAcc: {
      type: Boolean,
    },
  },
  data: () => ({
    quantity: {
      type: 'INFINITY',
      options: [
        { text: '不限', value: 'INFINITY' },
        { text: '自訂', value: 'CUSTOM' },
      ],
    },
    codeFormatOptions: [],
    // will assign a codeFormatChoice value in handleCodeFormat()
    // which depend on draft / contains singleCode / contains codes
    codeFormatChoice: '',
    codeTypeOptions: [],
    codeType: 'text',
    limit: {
      type: 'INFINITY',
      options: [
        { text: '不限', value: 'INFINITY' },
        { text: '自訂', value: 'CUSTOM' },
      ],
    },
    radioDefault: 'default',
    tagValidateRegEx: '',
    mcqrCodesMin: 1,
  }),
  computed: {
    ...mapGetters(['role']),
    isApprovedCoupon() {
      if (this.inputVal.reward.status && this.inputVal.reward.status === 'APPROVED') {
        return true;
      } return false;
    },
    // codeFormat: {
    //   get() {
    //     if (this.inputVal.couponMeta.singleCode.length) {
    //       return 'multiple_code';
    //     } return this.codeFormatChoice;
    //   },
    //   set(value) {
    //     this.codeFormatChoice = value;
    //   },
    // },
    maxRedeemRules() {
      const rules = {
        minValue: 1,
        required: true,
      };
      if (this.inputVal.reward.draftData.quantity !== 0) {
        rules.maxValue = this.inputVal.reward.draftData.quantity;
      }

      return rules;
    },
    minOriginalCost() {
      const rules = {
        minValue: '@所需U Fun',
      };
      if (this.inputVal.reward.originalCost === '') {
        rules.minValue = 0;
      }
      return rules;
    },
    mcqrCodesMinCal() {
      if (this.inputVal.reward.draftData.codes?.length) {
        return this.inputVal.reward.draftData.codes.length;
      }
      return this.mcqrCodesMin;
    },
    singleCodeRules() {
      const rules = {
        required: true,
      };
      if (this.inputVal.couponMeta.codeType !== 'link') {
        rules.max = 15;
      }
      if (this.inputVal.couponMeta.codeType === 'mc-qr') {
        rules.required = false;
      }
      return rules;
    },
    merchantReceivablePrice() {
      let merchantReceivablePrice = this.inputVal.reward.originalPrice || 0;
      if (this.inputVal.reward.price) {
        merchantReceivablePrice = this.inputVal.reward.price;
      }
      merchantReceivablePrice *= 0.95;
      // only two decimal points without rounding
      return merchantReceivablePrice.toFixed(3).slice(0, -1);
    },
    handleCodePlaceholder() {
      if (this.codeFormatChoice === 'multiple_code') {
        if (this.inputVal.couponMeta.codeType === 'link') {
          return '可輸入多個優惠連結，請按Enter 分隔優惠碼';
        }
        return '可輸入多個優惠碼，請按Enter 分隔優惠碼';
      }
      return '輸入統一優惠碼';
    },
    // enforceSubAccRules() {
    //   const rules = {
    //     required: true,
    //   };
    //   if (this.haveSubAcc === false && this.role === 'merchant') {
    //     rules.enforceSubAccRules = true;
    //   } else {
    //     rules.enforceSubAccRules = false;
    //   }
    //   return rules;
    // },
    couponCodeRules() {
      const rules = {
        maxCode: 40000,
      };
      if (this.inputVal.couponMeta.codeType !== 'mc-qr') {
        rules.required = true;
      } else {
        rules.required = false;
      }
      return rules;
    },
  },
  methods: {
    handleExcelResult(result) {
      if (this.isApprovedCoupon && this.codeFormatChoice === 'multiple_code') {
        this.inputVal.couponMeta.codes = [...new Set(
          this.inputVal.couponMeta.codes.concat(result),
        )];
      } else {
        this.inputVal.reward.draftData.codes = [...new Set(
          this.inputVal.reward.draftData.codes.concat(result),
        )];
      }
    },
    handleExcelError(msg) {
      this.$bvToast.toast(msg, {
        ...toastSettings,
        title: '錯誤格式',
        toaster: 'b-toaster-top-center',
      });
    },
    handleClearCode() {
      this.inputVal.couponMeta.singleCode = '';
      if (this.isApprovedCoupon) {
        this.inputVal.couponMeta.codes = [];
      } else {
        this.inputVal.reward.draftData.codes = [];
      }
    },
    handleCodeFormat() {
      const cMeta = this.inputVal.couponMeta;
      const cReward = this.inputVal.reward;
      const hasCodes = cMeta.codes && cMeta.codes.length > 0;
      const hasDraftCodes = cReward.draftData?.codes && cReward.draftData?.codes.length > 0;
      // there are 3 params to store the codes, single code, codes and draft codes,
      // once save and and approved the coupon, draftCodes will transfer to couponMeta codes
      // how to check: if 3 of codes are null / undefinded / length < 0
      // then set code format option to multiple_code, single_code,
      // if there are single code / multiple code,
      // than set the code option to only one choice that has choosen
      if (!cMeta.singleCode && !hasCodes && !hasDraftCodes) {
        if (this.isUFUN) {
          this.codeFormatOptions = [
            { text: '獨特優惠 (一次性優惠碼)', value: 'multiple_code' },
            { text: '通用優惠 (可供多次使用)', value: 'single_code' },
          ];
        } else {
          this.codeFormatOptions = [
            { text: '獨特優惠 (一次性優惠碼)', value: 'multiple_code' },
          ];
        }
        if (this.status === 'DRAFT' || !this.status) {
          this.codeFormatChoice = this.isUFUN ? 'single_code' : 'multiple_code';
        }
      } else if (this.inputVal.couponMeta.singleCode) {
        this.codeFormatOptions = [
          { text: '通用優惠 (可供多次使用)', value: 'single_code' },
        ];
        this.codeFormatChoice = 'single_code';
      } else {
        this.codeFormatOptions = [
          { text: '獨特優惠 (一次性優惠碼)', value: 'multiple_code' },
        ];
        this.codeFormatChoice = 'multiple_code';
      }
    },
    handleCodeType() {
      if (!this.inputVal.couponMeta.singleCode && !this.inputVal.couponMeta.codes) {
        this.codeTypeOptions = [
          { text: '文字優惠碼', value: 'text' },
          { text: '連結優惠', value: 'link' },
          // { text: 'QR CODE 優惠碼', value: 'mc-qr', disabled: true },
        ];
        if (this.haveSubAcc === true) {
          this.codeTypeOptions.push({ text: 'QR CODE 優惠碼', value: 'mc-qr', disabled: false });
        } else {
          this.codeTypeOptions.push({ text: 'QR CODE 優惠碼', value: 'mc-qr', disabled: true });
        }
      } else {
        this.codeTypeOptions = [
          {
            text: getCodeType(this.inputVal.couponMeta.codeType),
            value: this.inputVal.couponMeta.codeType,
          },
        ];
      }
    },
    handleMcQrCode() {
      this.codeFormatChoice = 'multiple_code';
    },
    batchDeleteCodes() {
      this.inputVal.reward.draftData.codes = [];
      this.$bvModal.hide('modal-remove-code');
    },
    handleCancel() {
      this.$bvModal.hide('modal-remove-code');
    },
  },
  subscriptions() {
    return {
      onDraftDataChange: this.$watchAsObservable('inputVal.reward.draftData', { deep: true }).pipe(
        pluck('newValue'),
        tap((draftData) => {
          if (draftData) {
            this.quantity.type = draftData?.quantity > 0 ? 'CUSTOM' : 'INFINITY';
            if (draftData.quantity) {
              if (this.inputVal.couponMeta.singleCode) {
                this.codeFormatChoice = 'single_code';
              }
            }
            if (this.codeFormatChoice === 'multiple_code') {
              if (!draftData.codes) {
                this.$set(this.inputVal.reward.draftData, 'codes', [...this.inputVal.couponMeta.codes]);
              }
            }
          } else if (this.inputVal.couponMeta.singleCode) {
            this.$set(this.inputVal.reward, 'draftData', {
              quantity: this.inputVal.reward.quantity,
            });
          } else {
            this.$set(this.inputVal.reward, 'draftData', {
              codes: this.inputVal.couponMeta.codes,
            });
          }
        }),
      ),
    };
  },
  watch: {
    'limit.type': function (type) {
      if (type === 'INFINITY') {
        this.inputVal.reward.maxRedeem = 0;
      } else if (!this.inputVal.reward.maxRedeem) {
        this.inputVal.reward.maxRedeem = 1;
      }
    },
    'inputVal.reward.maxRedeem': function (maxRedeem) {
      if (maxRedeem !== '') {
        this.limit.type = maxRedeem > 0 ? 'CUSTOM' : 'INFINITY';
      }
    },
    'quantity.type': function (type) {
      if (type === 'INFINITY') {
        this.inputVal.reward.draftData.quantity = 0;
      } else if (!this.inputVal.reward.draftData.quantity) {
        this.inputVal.reward.draftData.quantity = 1;
      }
    },
    'inputVal.reward.quantity': function (quantity) {
      if (this.inputVal.couponMeta.singleCode) {
        if (!this.inputVal.reward.draftData) {
          this.$set(this.inputVal.reward, 'draftData', { quantity });
        }
      }
      // set draftData.quantity when the coupon is approved
      if (this.inputVal.couponMeta.codes) {
        if (!this.inputVal.reward.draftData) {
          this.$set(this.inputVal.reward, 'draftData', { quantity });
        }
      }
    },
    'inputVal.reward.draftData.codes': function () {
      // sync draftData.quantity when codes are updated
      if (this.codeFormatChoice === 'multiple_code'
       && this.inputVal.couponMeta.codeType !== 'mc-qr') {
        this.inputVal.reward.draftData.quantity = this.inputVal.reward.draftData?.codes.length;
      }
    },
    'inputVal.couponMeta.codeType': function (type) {
      if (type === 'link') {
        this.tagValidateRegEx = /^(http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/;
      } else {
        this.tagValidateRegEx = /^[a-zA-Z0-9]{1,15}$/;
      }
      if (type === 'mc-qr') {
        this.handleMcQrCode();
      }
    },
    codeFormatChoice(choice) {
      // for mc-qr quantity type = 'CUSTOM'
      if (choice === 'multiple_code' && this.inputVal.couponMeta.codeType !== 'mc-qr') {
        this.quantity.type = 'INFINITY';
      }
    },
    haveSubAcc() {
      this.handleCodeType();
    },
    $route(to, from) {
      if (to.name !== from.name) {
        this.handleCodeFormat();
      }
    },
  },
  mounted() {
    this.handleCodeFormat();
    this.handleCodeType();
  },
};
</script>

<style lang="scss" scoped>
.code-input {
  & .single-code,
  .multi-code {
    display: none;
  }
  & .active {
    display: block;
  }
    & .h-auto {
      min-height: 90px !important;
      max-height:190px;
      overflow:scroll;
      display: inline-block;
    }
}

label.state {
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 21px;
}

.text-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 15px ;
  margin-bottom: 10px;
  color: #3A4046;
  & .left {
    text-align: left;
    // color: #7e8b97;
    letter-spacing: 0;
    line-height: 18px;
    font-size: 14px;
    font-weight: 400;
    margin-top: 3px;
  }
  & .right {
    font-size: 15px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 18px;
    text-align: right;
    margin-top: 4px;
  }
}

  .custom-limit-wrapper{
    height:auto;
    display:inline-block;
  }

  .custom-limit-group {
    height: 70px;
    width: 150px;
    display: inline-block;
  }

  .custom-limit-input {
    height: 35px;
    width: 100px;
    display: inline-block;
  }

  .ufunlabel-icon {
  height: 17px;
  width: 17px;
  margin-right: 5px;
  }

  .coupon-info {
    background-color: #f5fafe;
    width: 100%;
    padding: 9px 16px;
    border: 1px solid #e0effd;
    border-radius: 4px;
    margin-bottom: 24px;

    li {
      font-size: 14px;
      color: #174169;
      margin: 9px 0;
    }
  }

  .merchant-receivable-price {
    min-width: 150px;
    height: 100%;
    text-align: center;
    background-color: #f5fafe;
    border: 1px solid #e0effd;
    border-radius: 4px;
    padding-top: 6px;
    margin-top: -9%;
    // margin-top: -39px;

    .title {
      font-size: 15px;
      color: #3A4047;
    }
  }
</style>
